/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  Selector,
  Selector$Outbound,
  Selector$outboundSchema,
} from "./selector.js";

export type CreateTemporaryGrantForm = {
  /**
   * When the grant stops authorizing new requests. At least five minutes and at most 24 hours from now.
   */
  expiresAt: Date;
  /**
   * The principal receiving the access: an organization member (user:<id>), everyone (user:all), a role (role:organization:<id> or role:global:<id>) or an active agent (agent:<id>).
   */
  principalUrn: string;
  /**
   * Why the access is needed, recorded in the audit log.
   */
  reason?: string | undefined;
  /**
   * The scope to give, e.g. chat:read or log:read. Only scopes that grant access to read, use or manage resources can be given temporarily; org:admin, blocklist, auth client, risk policy and machine scopes cannot.
   */
  scope: string;
  /**
   * A constraint that narrows which resources a grant applies to.
   */
  selector?: Selector | undefined;
};

/** @internal */
export type CreateTemporaryGrantForm$Outbound = {
  expires_at: string;
  principal_urn: string;
  reason?: string | undefined;
  scope: string;
  selector?: Selector$Outbound | undefined;
};

/** @internal */
export const CreateTemporaryGrantForm$outboundSchema: z.ZodMiniType<
  CreateTemporaryGrantForm$Outbound,
  CreateTemporaryGrantForm
> = z.pipe(
  z.object({
    expiresAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    principalUrn: z.string(),
    reason: z.optional(z.string()),
    scope: z.string(),
    selector: z.optional(Selector$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      expiresAt: "expires_at",
      principalUrn: "principal_urn",
    });
  }),
);

export function createTemporaryGrantFormToJSON(
  createTemporaryGrantForm: CreateTemporaryGrantForm,
): string {
  return JSON.stringify(
    CreateTemporaryGrantForm$outboundSchema.parse(createTemporaryGrantForm),
  );
}
